import { useMutation } from '@tanstack/react-query';
import { authResetPasswordRequestCreate } from '@wellstone-solutions/api/v2';

import type {
  PasswordResetRequest,
  PasswordResetRequestInputRequest,
} from '@wellstone-solutions/api/v2';
import type { AxiosError, AxiosResponse } from 'axios';

const useForgotPassword = () => {
  return useMutation<
    AxiosResponse<PasswordResetRequest>,
    AxiosError<{ [key: string]: string[] }>,
    PasswordResetRequestInputRequest
  >({
    mutationFn: (input) =>
      authResetPasswordRequestCreate({
        ...input,
        platform: 'harbor',
      }),
  });
};

export { useForgotPassword };
